import { Divider, Flex, Text } from "@fluentui/react-northstar";
import { Card, Empty, Progress } from "antd";
import React from "react";

const RubricPerformance = ({
  rubricPerformance = {
    criteria: [
      {
        label: "Content Mastery",
        value: 78,
        description: "Understanding and application of core concepts",
      },
      {
        label: "Critical Thinking",
        value: 65,
        description: "Analysis and evaluation of information",
      },
      {
        label: "Organization & Structure",
        value: 82,
        description: "Logical flow and coherent presentation",
      },
      {
        label: "Evidence & Support",
        value: 71,
        description: "Use of relevant examples and citations",
      },
      {
        label: "Language & Mechanics",
        value: 89,
        description: "Grammar, spelling, and writing style",
      },
    ],
    summary: {
      highestPerforming: "Language & Mechanics",
      needsImprovement: "Critical Thinking",
    },
  },
}) => {
  return (
    <Card
      title={"Rubric Performance"}
      // extra={
      //   <Select size="small" defaultValue="All Courses" style={{ width: 120 }}>
      //     <Option value="all">All Courses</Option>
      //   </Select>
      // }
      style={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        borderRadius: "8px",
      }}
      bodyStyle={{ height: "100%", flexGrow: 1 }}
      className="shadow"
    >
      {rubricPerformance.criteria.length > 0 ? (
        <>
          <Flex column style={{ height: "100%", flexGrow: 1 }}>
            <div style={{ flexGrow: 1, maxHeight: "357px", overflowY: "auto" }}>
              {rubricPerformance.criteria.map((item) => (
                <div key={item.label}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      marginBottom: 4,
                    }}
                  >
                    <Text
                      style={{
                        fontSize: 14,
                        fontWeight: 500,
                        color: "#374151",
                      }}
                    >
                      {item.label}
                    </Text>
                    <Text
                      style={{
                        fontSize: 14,
                        fontWeight: 500,
                        color: "#374151",
                      }}
                    >
                      {item.value}% met
                    </Text>
                  </div>
                  <Progress
                    percent={item.value}
                    showInfo={false}
                    strokeColor="#2563eb"
                    trailColor="#e5e7eb"
                    strokeWidth={10}
                    style={{ marginBottom: 8 }}
                  />
                </div>
              ))}
            </div>

            <Divider style={{ margin: "16px 0" }} />

            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <div>
                <Text type="secondary" style={{ fontSize: 12 }}>
                  Highest Performing
                </Text>
                <div
                  style={{ fontSize: 14, fontWeight: 500, color: "#1f2937" }}
                >
                  {rubricPerformance.summary.highestPerforming}
                </div>
              </div>
              <div style={{ textAlign: "right" }}>
                <Text type="secondary" style={{ fontSize: 12 }}>
                  Needs Improvement
                </Text>
                <div
                  style={{ fontSize: 14, fontWeight: 500, color: "#1f2937" }}
                >
                  {rubricPerformance.summary.needsImprovement}
                </div>
              </div>
            </div>
          </Flex>
        </>
      ) : (
        <Flex vAlign="center" hAlign="center" style={{ height: "100%" }}>
          <Empty />
        </Flex>
      )}
    </Card>
  );
};

export default RubricPerformance;
